module.exports = __webpack_public_path__ + "img/Henkel.3ff52814.jpg";